import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { OpeningHourViewModel } from 'autogen/swagger/all';
import { Body } from 'components/generic/typography';
import { stringToKey } from 'modules/helpers/strings';

const Container = styled.div``;

const Row = styled.div`
    display: table-row;
`;

const StyledBody = styled(Body)`
    display: table-cell;
    padding-right: ${Spacing16};

    &:last-child {
        padding-right: 0;
    }
`;

interface IProps {
    hours: OpeningHourViewModel[];
}

export default function SupportHours(props: IProps): JSX.Element {
    const { hours } = props;

    return (
        <Container>
            {hours.map((open) => {
                const { weekDay, timePeriod } = open;

                return (
                    <Row key={stringToKey(weekDay)}>
                        <StyledBody forwardedAs="span" size="M">
                            {weekDay}
                        </StyledBody>
                        <StyledBody forwardedAs="span" size="M">
                            {timePeriod}
                        </StyledBody>{' '}
                    </Row>
                );
            })}
        </Container>
    );
}
